module.exports = __webpack_public_path__ + "static/media/8.50f0d9df.png";